import { render } from "./UserImage.vue?vue&type=template&id=7709fbfa"
import script from "./UserImage.vue?vue&type=script&lang=js"
export * from "./UserImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__